/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

export const emailTemplateSlice = createApi({
	reducerPath: "emailTemplateSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["emailTemplate"],
	endpoints: builder => ({
		getEmailTemplateList: builder.query({
			query: () => {
				return {
					url: `pd-marketing/email-templates`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getEmailTemplateListPaginated: builder.query({
			query: ({ page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-marketing/email-templates/paginate?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getPdMarketingList: builder.query({
			query: ({ page_no = 1, limit = 10, sort_by, sort_dir, search, status }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);
				if (status) params.append("status", status);

				return {
					url: `pd-marketing/list?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getPDMarketingData: builder.query({
			query: ({ id }) => {
				return {
					url: `pd-marketing/edit/${id}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		sendMessage: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: "/pd-marketing/create",
				method: "POST",
				body: data,
				headers: {
					accept: "application/json",
				},
			}),
		}),

		createEmailTemplate: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: "pd-marketing/email-template/create",
				method: "POST",
				body: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),

		updateEmailTemplate: builder.mutation<any, { id: string; data: any }>({
			query: ({ id, data }) => ({
				url: `pd-marketing/email-template/${id}`,
				method: "PUT",
				body: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),

		getEmailTemplate: builder.query<any, { id: string }>({
			query: ({ id }) => {
				return {
					url: `pd-marketing/email-template/${id}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		removeEmailTemplate: builder.mutation<any, { id: string }>({
			query: ({ id }) => ({
				url: `pd-marketing/email-template/remove/${id}`,
				method: "DELETE",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),
		sendTestEmail: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: `pd-marketing/email-template-seed`,
				method: "POST",
				body: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),

		createEmailSequence: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: "pd-email-sequence/create",
				method: "POST",
				body: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),
		getEmailSequenceById: builder.query({
			query: $id => {
				return {
					url: `pd-email-sequence/getbyid/${$id}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
		updateEmailSequence: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: "pd-email-sequence/update",
				method: "PUT",
				body: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),
		getEmailSequenceList: builder.query({
			query: ({ page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-email-sequence/list?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
		getEmailSequence: builder.query({
			query: () => {
				return {
					url: `pd-email-sequence/get`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		submit: builder.mutation({
			query: (formData: FormData) => ({
				url: `pd-email-sequence/submit`,
				method: "POST",
				body: formData,
			}),
		}),
		getEmailDripList: builder.query({
			query: ({ page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-email-sequence/paginated-list?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
		toggleEmailSequenceStatus: builder.mutation<any, { id: string; is_active: "Y" | "N" }>({
			query: ({ id, is_active }) => ({
				url: `pd-email-sequence/toggle-status/${id}`,
				method: "POST",
				body: { is_active },
				headers: {
					"Content-Type": "application/json",
				},
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		getDripRecipients: builder.query({
			query: ({ drip_id, page_no = 1, limit = 50, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-email-sequence/drip/${drip_id}/recipients?${params.toString()}`,
					method: "GET",
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getBatches: builder.query<any, { id: string }>({
			query: ({ id }) => ({
				url: `pd-email-sequence/get-batch/${id}`,
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),

		validateEmailsForProfileCreation: builder.mutation({
			query: (data: any) => ({
				url: `pd-marketing/validate-emails-for-profile-creation`,
				method: "POST",
				body: data,
			}),
		}),

		createProfiles: builder.mutation({
			query: (formData: FormData) => ({
				url: `pd-marketing/profile-create`,
				method: "POST",
				body: formData,
			}),
		}),

		getProfile: builder.query<any, { id: string }>({
			query: ({ id }) => ({
				url: `pd-marketing/profile-get-single/${id}`,
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
		}),

		updateProfile: builder.mutation<any, { id: number; data: FormData }>({
			query: ({ id, data }) => ({
				url: `pd-marketing/profile-update/${id}`,
				method: "POST",
				body: data,
			}),
		}),

		getProfileListHistory: builder.query<any, { id: string }>({
			query: ({ id }) => ({
				url: `pd-marketing/profile-list-history/${id}`,
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getProfilesPaginated: builder.query({
			query: ({
				page_no = 1,
				limit = 10,
				sort_by,
				sort_dir,
				search,
				agency_id,
				status,
				start_date,
				end_date,
				clicker,
			}) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);
				if (agency_id) params.append("agency_id", agency_id);
				if (status) params.append("status", status);
				if (start_date) params.append("start_date", start_date);
				if (end_date) params.append("end_date", end_date);
				if (clicker) params.append("clicker", clicker);

				return {
					url: `pd-marketing/profile-get?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		assignProfilesToList: builder.mutation({
			query: (data: { list_id: string; profile_ids: string[] }) => ({
				url: `pd-marketing/profile-assign-list`,
				method: "POST",
				body: data,
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		updateProfileStatusInList: builder.mutation({
			query: (data: { list_id: string; profile_id: string; status: string }) => ({
				url: `pd-marketing/list-profile-status-update`,
				method: "POST",
				body: data,
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		createList: builder.mutation({
			query: (formData: FormData) => ({
				url: `pd-marketing/list-create`,
				method: "POST",
				body: formData,
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		updateList: builder.mutation({
			query: (formData: FormData) => ({
				url: `pd-marketing/list-update`,
				method: "POST",
				body: formData,
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		deleteList: builder.mutation({
			query: (id: string) => ({
				url: `pd-marketing/list-delete/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["emailTemplate"],
		}),

		getList: builder.query<any, { agency_id?: string } | void>({
			query: params => {
				const agencyId = params && "agency_id" in params ? params.agency_id : null;
				return {
					url: `pd-marketing/list-get-names${agencyId ? `?agency_id=${agencyId}` : ""}`,
					method: "GET",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
				};
			},
		}),

		getListProfiles: builder.query<any, { id: string | undefined }>({
			query: ({ id }) => ({
				url: `pd-marketing/list-profile-get/${id}`,
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getListSubscribers: builder.query({
			query: ({ id, page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());
				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-marketing/list-get-subscribers/${id}?${params.toString()}`,
					method: "GET",
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getListBounced: builder.query({
			query: ({ id, page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());
				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-marketing/list-get-bounced/${id}?${params.toString()}`,
					method: "GET",
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getListUnsubscribed: builder.query({
			query: ({ id, page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());
				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-marketing/list-get-unsubscribed/${id}?${params.toString()}`,
					method: "GET",
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getListOpenersClickers: builder.query({
			query: ({ id, page_no = 1, limit = 10, sort_by, sort_dir, search }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());
				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);

				return {
					url: `pd-marketing/list-get-openers/${id}?${params.toString()}`,
					method: "GET",
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		// getListForAssign: builder.query<any, void>({
		// 	query: () => ({
		// 		url: `pd-marketing/list-get-names-assign`,
		// 		method: "GET",
		// 		headers: {
		// 			"Content-Type": "application/x-www-form-urlencoded",
		// 		},
		// 	}),
		// }),

		getListByAgencyId: builder.query<any, string>({
			query: agencyId => ({
				url: `pd-marketing/list-get-by-agency/${agencyId}`,
				method: "GET",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
			}),
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),

		getListPaginated: builder.query({
			query: ({ page_no = 1, limit = 10, sort_by, sort_dir, search, agency_id }) => {
				const params = new URLSearchParams();
				params.append("limit", limit.toString());
				params.append("page_no", page_no.toString());

				if (sort_by) params.append("sort_by", sort_by);
				if (sort_dir) params.append("sort_dir", sort_dir);
				if (search) params.append("search", search);
				if (agency_id) params.append("agency_id", agency_id);

				return {
					url: `pd-marketing/list-get?${params.toString()}`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
		getWebhookUrl: builder.query({
			query: ({ id }) => {
				return {
					url: `pd-marketing/lists/${id}/webhook`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
		getShopifyWebhookUrl: builder.query({
			query: ({ id }) => {
				return {
					url: `pd-marketing/lists/${id}/shopify-webhook`,
				};
			},
			providesTags: ["emailTemplate"],
			keepUnusedDataFor: 0,
		}),
	}),
});

export const {
	useGetEmailTemplateListQuery,
	useGetPDMarketingDataQuery,
	useUpdateEmailTemplateMutation,
	useGetEmailTemplateQuery,
	useGetPdMarketingListQuery,
	useSendMessageMutation,
	useGetEmailTemplateListPaginatedQuery,
	useCreateEmailTemplateMutation,
	useRemoveEmailTemplateMutation,
	useSendTestEmailMutation,
	useCreateEmailSequenceMutation,
	useGetEmailSequenceByIdQuery,
	useUpdateEmailSequenceMutation,
	useGetEmailSequenceListQuery,
	useGetEmailSequenceQuery,
	useSubmitMutation,
	useGetEmailDripListQuery,
	useGetDripRecipientsQuery,
	useGetBatchesQuery,
	useCreateProfilesMutation,
	useGetListByAgencyIdQuery,
	useValidateEmailsForProfileCreationMutation,
	useGetProfileQuery,
	useUpdateProfileMutation,
	useGetProfilesPaginatedQuery,
	useGetProfileListHistoryQuery,
	useCreateListMutation,
	useUpdateListMutation,
	useDeleteListMutation,
	useGetListQuery,
	useGetListProfilesQuery,
	useGetListSubscribersQuery,
	useGetListBouncedQuery,
	useGetListUnsubscribedQuery,
	useGetListOpenersClickersQuery,
	// useGetListForAssignQuery,
	useGetListPaginatedQuery,
	useAssignProfilesToListMutation,
	useUpdateProfileStatusInListMutation,
	useGetWebhookUrlQuery,
	useGetShopifyWebhookUrlQuery,
	useToggleEmailSequenceStatusMutation,
} = emailTemplateSlice;
